import { FC } from "react";
import { motion } from "framer-motion";
import { round } from "@jurijtokarski/calc";

import { Amount, Measure } from "../utils/context";

import "./HomeProgress.css";
import { useStorage } from "../utils/useStorage";
import { Link } from "./Link";
import { RouteKey } from "../configs/routes";

const formattedMeasures = Object.freeze({
  [Measure.ML]: "l",
  [Measure.OZ]: "oz",
})

const formatPercentage = (progress: number) => round(progress * 100, 0);

const formatOZAmount = (amount: Amount) => {
  if (!amount) {
    return amount;
  }

  return amount.toFixed(0);
}

const formatMLAmount = (amount: Amount) => {
  if (!amount) {
    return amount;
  }

  const value = amount / 1000;

  if (amount < 1000) {
    return value.toFixed(2);
  }

  return value.toFixed(1);
}

const formatAmount = (amount: Amount, measure: Measure) => {
  if (measure === Measure.ML) {
    return formatMLAmount(amount);
  }

  return formatOZAmount(amount);
}

export const HomeProgress: FC = () => {
  const { todayProgress, todayAmount, configGoal, configMeasure, isReady } = useStorage();

  const percent = formatPercentage(todayProgress);
  const amount = formatAmount(todayAmount, configMeasure);
  const goal = formatAmount(configGoal, configMeasure);
  const measure = formattedMeasures[configMeasure];

  return (
    <motion.div
      className="home-progress"
      initial={{
        scale: isReady ? 1 : 0,
        y: isReady ? 0 : 400
      }}
      animate={{
        scale: 1,
        y: 0
      }}
      transition={{
        duration: 0.5,
        ease: [0.19, 1, 0.22, 1]
      }}
    >
      <div className="home-progress__percentage">
        {percent}
      </div>
      <div className="home-progress__amount">
        {amount} of <Link route={RouteKey.SET_GOAL} className="home-progress__amount-link" >{goal} {measure}</Link>
      </div>
    </motion.div>
  )
}